export interface ButtonStyles {
  primary: (isLoading?: boolean) => string;
  secondary: (isLoading?: boolean) => string;
  ternary: (isLoading?: boolean) => string;
}
export const buttonStyles: ButtonStyles = {
  primary: isLoading => `
    color: var(--color5);
    border: 1px solid var(--color2);
    background-color: var(--color2);
    transition: all 0.2s ease;

    &:hover {
      background-color: var(--color1);
      border-color: var(--color1);
    }

    ${
      isLoading
        ? ``
        : `
            &:disabled {
              color: var(--color7);
              background-color: var(--color8);
              border-color: var(--color10);
            }
          `
    }
  `,
  secondary: isLoading => `
    color: var(--color1);
    border: 1px solid var(--color10);
    background-color: var(--color5);
    transition: all 0.2s ease;

    &:hover {
      border-color: var(--color2);
      background-color: var(--color14);
    }

    ${
      isLoading
        ? ``
        : `
          &:disabled {
            color: var(--color7);
            border: 1px solid var(--color10);
            background-color: var(--color8);
        }
    }`
    }
  `,
  ternary: () => `
    color: var(--color9);
    border: 1px solid var(--color10);
    background-color: var(--color5);
    transition: all 0.2s ease;

    &:hover {
      border-color: var(--color9);
      color: var(--color6);
    }

    &:disabled {
      color: var(--color7);
      border: 1px solid var(--color10);
      background-color: var(--color8);
    }
  `,
};
